import { render, staticRenderFns } from "./jzbs.vue?vue&type=template&id=0c619475&scoped=true&"
import script from "./jzbs.vue?vue&type=script&lang=js&"
export * from "./jzbs.vue?vue&type=script&lang=js&"
import style0 from "./jzbs.vue?vue&type=style&index=0&id=0c619475&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c619475",
  null
  
)

export default component.exports